module.exports = __webpack_public_path__ + "img/box-txprog.4c3183e9.png";